jQuery(document).ready(function($) {

	$('.nav__toggle').click(function(e) {
		e.preventDefault();
		$nav.stop().toggleClass('nav--active');
	});

	$('#nav a').click(function() {
		var $parent = $(this).parent('.menu-item');

		// If doesn't have a child or not mobile
		if($(window).width() >= 992 || !$parent.hasClass('menu-item-has-children')) {
			$nav.stop().toggleClass('nav--active');
		}
	});

	$('#nav nav > ul > .menu-item').hover(function() {
		if($(window).width() >= 992) {
			if($(this).hasClass('menu-item-has-children')) {
				$('#nav-right').css({'opacity': '0', 'visibility': 'hidden'});
			} else {
				$('#nav-right').css({'opacity': '1', 'visibility': 'visible'});
			}
			$('#nav .sub-menu').hide();
			$('.sub-menu', $(this)).show();
		}
	});

	$('#nav .menu-item-has-children > a').click(function(event) {
		if($(window).width() < 991) {
			event.preventDefault();
			var $parent = $(this).parent('.menu-item');
			$parent.toggleClass('menu-item-has-children--active');
			$('.sub-menu', $parent).slideToggle();
		}
	});

	$('#nav .menu-item-has-children').each(function() {
		var link = $('a', $(this)).attr('href');
		$('ul', $(this)).append('<li class="menu-item menu-item__all d-lg-none"><a href="' + link + '">View All</a></li>')
	});

});
